import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { browserHistory } from 'react-router';
import { ContentCourseFailureAttemptRateListService } from '../../services/ContentListService';
import { englishLevelCourses } from '../../../../../core/consts';
import ContentCourseFailureAttemptRateTable from './ContentCourseFailureAttemptRateTable';

class ContentCourseFailureAttemptRateTableContainer extends React.Component {
  componentDidMount() {
    ContentCourseFailureAttemptRateListService.load(
      this.props.unitId ? 'unit' : this.props.moduleId ? 'module' : 'course',
      this.props.unitId || this.props.moduleId || this.props.courseId
    );
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      this.props.unitId !== prevProps.unitId ||
      this.props.moduleId !== prevProps.moduleId ||
      this.props.courseId !== prevProps.courseId
    ) {
      ContentCourseFailureAttemptRateListService.load(
        this.props.unitId ? 'unit' : this.props.moduleId ? 'module' : 'course',
        this.props.unitId || this.props.moduleId || this.props.courseId
      );
    }
  }

  render() {
    return (
      <ContentCourseFailureAttemptRateTable
        loading={
          ContentCourseFailureAttemptRateListService.fetchCurrent.fetching ||
          ContentCourseFailureAttemptRateListService.fetchPrevious.fetching
        }
        values={toJS(ContentCourseFailureAttemptRateListService.getList()).map((item) =>
          Object.assign({}, item, {
            level: get(
              englishLevelCourses.find((c) => c.label === item.name),
              'value',
              null
            ),
          })
        )}
        nameColumnPath={this.props.courseId || this.props.moduleId || this.props.unitId ? 'order' : 'level'}
        nameColumnRender={(row) => {
          if (this.props.unitId) {
            return `${row.order} - ${ContentCourseFailureAttemptRateListService.getGroupLabel(row.group)} - ${
              row.type
            }`;
          } else if (this.props.courseId || this.props.moduleId) {
            return `${row.group} - ${row.order} - ${row.name}`;
          } else {
            return row.name;
          }
        }}
        onSelect={(row) => {
          if (this.props.unitId) {
            return false;
          }
          if (this.props.moduleId) {
            browserHistory.push(
              `/kpis/content/course/${this.props.courseId}/module/${this.props.moduleId}/unit/${row.id}/details`
            );
          } else if (this.props.courseId) {
            browserHistory.push(`/kpis/content/course/${this.props.courseId}/module/${row.id}/details`);
          } else {
            browserHistory.push(`/kpis/content/course/${row.id}/details`);
          }
        }}
        formatter={ContentCourseFailureAttemptRateListService.getFormattedValue}
        feedbackColorRender={ContentCourseFailureAttemptRateListService.getFeedbackColor}
      />
    );
  }
}

ContentCourseFailureAttemptRateTableContainer.propTypes = {
  courseId: PropTypes.string,
  moduleId: PropTypes.string,
  unitId: PropTypes.string,
};

export default observer(ContentCourseFailureAttemptRateTableContainer);
